module.exports = __webpack_public_path__ + "static/media/500.bbca7db7.png";